export default "__VITE_ASSET__96qSAyup__"